import { ShieldCheck, Camera, LayoutList, MessageCircle } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";

const cards = [
  [ShieldCheck, "Independent assessment", "We inspect independently and report what can be observed within the agreed scope."],
  [Camera, "Clear photographic evidence", "Relevant visible findings are documented with photographs where practicable."],
  [LayoutList, "Actionable reporting", "Findings are organised clearly so they can be followed up with the responsible party."],
  [MessageCircle, "Direct support", "Speak directly with the Fedari team before and after the inspection."],
];

export default function WhyChoose() {
  return (
    <section className="py-20 lg:py-24 bg-white" data-testid="why-choose">
      <div className="wrap">
        <SectionHead eyebrow="Why Fedari" title="Why owners choose Fedari." />
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {cards.map(([Icon, t, d], i) => (
            <Reveal key={t} delay={(i % 4) * 0.05}>
              <div className="border border-line rounded-[14px] p-6 h-full bg-white hover:border-blue hover:shadow-sm transition-all">
                <div className="w-11 h-11 rounded-[10px] bg-blue-50 grid place-items-center text-blue mb-4"><Icon size={21} /></div>
                <h3 className="text-[1.08rem] font-semibold mb-1.5">{t}</h3>
                <p className="text-muted text-[0.88rem] leading-relaxed">{d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
